/// <amd-module name="Repos/Views/PullRequest/Components/ActivityFeed/ActivityCards/ActivityCardSubtle" />
import * as React from "react";
import { GitPullRequestCommentThread } from "Repos/Common/Contracts/Git";
import { IGitPullRequestCommentThreadModel } from "Repos/Views/PullRequest/Discussion/PullRequestDiscussionThreadService";
import { IReadonlyObservableValue } from "VSS/Core/Observable";
import { Ago } from "VSSUI/Ago";

export interface IActivityCardSubtleProps {
    createDate: Date;
}

export const ActivityCardSubtle: React.FunctionComponent<IActivityCardSubtleProps> = props => {
    return (
        <div className="flex-row flex-grow margin-horizontal-20 scroll-hidden" role="heading" aria-level={3}>
            <div className="activity-card-subtle flex-row flex-grow flex-center flex-wrap">{props.children}</div>
            <div className="flex-row flex-noshrink margin-left-4">
                <Ago className="activity-card-time font-size secondary-text" date={props.createDate} />
            </div>
        </div>
    );
};

export interface IActivityCardSharedProps {
    isShim?: boolean;
    isShimObservable?: IReadonlyObservableValue<boolean>;
    thread: GitPullRequestCommentThread;
    threadModel: IGitPullRequestCommentThreadModel;
}
